import { defineMessages } from 'react-intl';

export default defineMessages({
    modalWarning: {
        id: 'gw-policychange-ba.modalWarning',
        defaultMessage: 'New underwriting issues have been raised. Please review and/or refer to underwriter.'
    }
});